<template>
  <div v-show="canManage || contacts.length > 0">
    <div class="-mb-2 flex flex-wrap print:flex-col" v-if="contacts.length > 0">
      <div
        class="mr-2 mb-2 rounded bg-gray-100 px-4 py-3 print:p-0"
        v-for="contact in contacts"
        :key="contact.id"
      >
        <div class="flex items-baseline justify-between">
          <div class="leading-tight">
            <h5 class="mb-0 font-semibold" v-text="displayName(contact)"></h5>
            <span class="text-sm text-gray-500" v-if="contact.role" v-text="contact.role"></span>
          </div>
          <span
            class="far fa-times ml-4 cursor-pointer p-1 hover:text-brand-500 print:hidden"
            v-if="canManage"
            @click="deleteContact(contact)"
          ></span>
        </div>
        <div
          v-if="showDetails && contact.details"
          v-html="contact.details"
          class="mt-2 text-sm"
        ></div>
        <div v-if="canManage" class="mt-1 print:hidden">
          <a :href="contact.link" class="text-sm">
            {{ $t('activity_contacts.view_contact') }}
            <span class="far fa-angle-double-right"></span>
          </a>
        </div>
      </div>
    </div>
    <div v-if="canManage && hasPossibleContacts" class="print:hidden">
      <hr class="mt-5 mb-6" v-if="contacts.length > 0" />
      <div class="flex flex-col sm:flex-row">
        <select
          class="form-select rounded-b-none border-b-0 sm:rounded-l sm:rounded-r-none sm:border-b sm:border-r-0"
          v-model.number="newContactId"
        >
          <option value="" v-text="$t('activity_contacts.add_placeholder')"></option>
          <optgroup v-for="(contacts, key) in possibleContacts" :key="key" :label="key">
            <option
              v-for="contact in contacts"
              :key="contact.id"
              :value="contact.id"
              v-text="displayName(contact)"
            ></option>
          </optgroup>
        </select>
        <button
          class="btn btn-outline-primary rounded-t-none sm:rounded-t sm:rounded-l-none"
          v-text="$t('activity_contacts.add_button')"
          :disabled="!newContactId"
          @click="addContact"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activityId: {
      type: Number,
      required: true,
    },
    showDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      contacts: [],
      allContacts: [],
      canManage: false,
      newContactId: '',
    }
  },
  methods: {
    deleteContact(contactToDelete) {
      axios
        .delete('/api/activities/' + this.activityId + '/contacts/' + contactToDelete.id)
        .then(({ data, headers }) => {
          this.contacts = this.contacts.filter((contact) => {
            return contact.id != contactToDelete.id
          })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    addContact() {
      let contactIdToAdd = this.newContactId
      this.newContactId = ''

      if (!contactIdToAdd) {
        return
      }

      axios
        .post('/api/activities/' + this.activityId + '/contacts', {
          contact_id: contactIdToAdd,
        })
        .then(({ data }) => {
          this.contacts = data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    displayName(contact) {
      return contact.name + (contact.company ? ' - ' + contact.company : '')
    },
  },
  computed: {
    possibleContacts() {
      let connectedContactIds = this.contacts.map((contact) => contact.id)

      let groupedContacts = this.allContacts
        .filter((contact) => {
          return !connectedContactIds.includes(contact.id)
        })
        .reduce((result, contact) => {
          if (result[contact.role] == undefined) {
            result[contact.role] = []
          }
          result[contact.role].push(contact)
          return result
        }, {})

      const orderedGroupedContacts = {}
      Object.keys(groupedContacts)
        .sort()
        .forEach(function (key) {
          orderedGroupedContacts[key] = groupedContacts[key]
        })

      if (orderedGroupedContacts[null]) {
        orderedGroupedContacts[this.$t('activity_contacts.other_role')] =
          orderedGroupedContacts[null]
        delete orderedGroupedContacts[null]
      }

      return orderedGroupedContacts
    },
    hasPossibleContacts() {
      return Object.keys(this.possibleContacts).length > 0
    },
  },
  created() {
    axios
      .get('/api/activities/' + this.activityId + '/contacts')
      .then(({ data, headers }) => {
        this.allContacts = data.all
        this.contacts = data.connected
        this.canManage = !!headers['x-contact-manage']
      })
      .catch((error) => {
        console.log(error)
      })
  },
}
</script>
